/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-empty */
import React, { Component } from 'react';
import _ from 'underscore';
import PropTypes from "prop-types";
import styles from '../Contact.module.css';
import * as storeRepo from '../../../shared/repos/graphql/store';
import InputSearchBox from '../../../components/InputSearchBox/InputSearchBox';

class StoreField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stores: []
    };
  }

  componentDidMount() {
    this.getStores();
  }

  async getStores() {
    try {
      const response = await storeRepo.regularStores();

      const stores = _.pluck(response.data.regularStores, "name").sort();

      this.setState({
        stores
      });
    } catch (exception) {}
  }

  setStore = (store) => {
    const { onChange } = this.props;
    onChange(store)
  };

  render() {
    const { store, isRequired, prompt, promptValue } = this.props;
    const { stores } = this.state;
    const storesList = stores.map(item => {
      return {
        label: item,
        value: item
      };
    });
    let promptItem = null;
    if (prompt) {
      promptItem = {
        label: prompt,
        value: promptValue
      };
      storesList.unshift(promptItem);
    }
    const label = isRequired ? "Bakery*" : "Bakery";
    return (
      <div className={styles.dropDownWrapper}>
        <InputSearchBox
          prompt={prompt}
          label={label}
          items={storesList}
          onSelectItem={this.setStore}
          selectedItem={store}
        />
      </div>
    );
  }
}

StoreField.propTypes = {
  isRequired: PropTypes.bool,
  store: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  prompt: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  promptValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  onChange: PropTypes.func,
}

StoreField.defaultProps = {
  isRequired: false,
  prompt: null,
  promptValue: null,
  onChange: () => {},
  store: null,
}

export default StoreField;
